import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Dimmer, Loader } from "semantic-ui-react";

import * as layoutActions from "../../../actions/e-loketLayoutActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import orbMigratieApi from "../../../api/shared/orbMigratieApi";
import redirector from "../../../util/redirector";
import TextInput from "../../common/TextInput";
import LoaderTekstWithTimeout from "../../common/LoaderTekstWithTimeout";

const OVERZICHT_ROUTE = "/e-loket/organisatoroverzicht";

class OrbMigratiePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            codes: [""],
            fouten: {},
            fase: "invoer"
        };
    }

    componentDidMount() {
        this.props.loadLayout(this.organisatieNaam());
    }

    organisatieNaam() {
        const security = this.props.security;
        if (!security)
            return "";

        const organisaties = security.organisations || [];
        const huidig = (security.currentOrganisation || "").replace(/[.-]/g, "");
        const match = organisaties.find(o => o && o.organisatienummer === huidig);

        return (match || organisaties[0] || {}).naam || "";
    }

    ingevuldeCodes() {
        return this.state.codes.map(code => code.trim()).filter(code => code.length > 0);
    }

    onCodeChange = (index, value) => {
        const codes = this.state.codes.slice();
        codes[index] = value;
        this.setState({ codes });
    };

    onAddRow = () => {
        this.setState({ codes: this.state.codes.concat("") });
    };

    onRemoveRow = (index) => {
        const codes = this.state.codes.slice();
        codes.splice(index, 1);
        this.setState({ codes: codes.length ? codes : [""] });
    };

    onGaVerder = () => {
        const codes = this.ingevuldeCodes();

        if (codes.length === 0) {
            redirector.goTo(OVERZICHT_ROUTE);
            return;
        }

        this.setState({ fase: "koppelen", fouten: {} });
        this.props.ajaxActions.started();

        orbMigratieApi.link(codes)
            .then((response) => {
                this.props.ajaxActions.ended();
                const resultaat = response.data;

                if (!resultaat || !resultaat.isSuccess) {
                    this.toonFouten(resultaat ? resultaat.errors : []);
                    return;
                }

                this.startMigratie(resultaat.nieuweAccountId, resultaat.oudeAccountIds);
            })
            .catch((ex) => {
                this.props.ajaxActions.failed();
                this.setState({ fase: "invoer" });
                this.props.throwException(ex);
            });
    };

    toonFouten(errors) {
        const map = {};
        (errors || []).forEach(error => { map[(error.aanmeldCode || "").trim()] = error.errorMessage; });

        this.setState({ fase: "invoer", fouten: map });
    }

    startMigratie(nieuweAccountId, oudeAccountIds) {
        this.setState({ fase: "migreren" });

        orbMigratieApi.migrate(nieuweAccountId, oudeAccountIds)
            .then(() => {
                redirector.goTo(OVERZICHT_ROUTE);
            })
            .catch((ex) => {
                this.setState({ fase: "invoer" });
                this.props.throwException(ex);
            });
    }

    render() {
        const migreren = this.state.fase === "migreren";

        return (
            <Fragment>
                {this.renderInvoer()}
                <Dimmer active={migreren} page>
                    <Loader size="large">
                        {migreren
                            ? <LoaderTekstWithTimeout wait={500}>
                                Even geduld aub.<br />
                                Het koppelen van je oude aanmeldcodes vereist heel wat bewerkingen achter de schermen.<br />
                                Dit kan enkele minuten duren.
                            </LoaderTekstWithTimeout>
                            : null}
                    </Loader>
                </Dimmer>
            </Fragment>
        );
    }

    renderInvoer() {
        const codes = this.state.codes;
        const bezig = this.state.fase !== "invoer";

        return (
            <section className="o-page__main u-clear" role="main">
                <div className="c-section-wrap">
                    <div className="c-section c-section--blue">
                        <header className="c-section__header">
                            <h2 className="title">Oude aanmeldcode(s)</h2>
                        </header>
                        <div className="c-section__body">
                            <div className="c-content-block">
                                <p className="o-col-12 spaced-text">
                                    <strong className="blue-text">
                                        DIT SCHERM GELDT ENKEL VOOR ORGANISATOREN VAN CYCLO-, VELDTOER- OF GRAVELTOCHTEN.<br />
                                        ANDERE ORGANISATOREN KUNNEN DIT SCHERM NEGEREN EN OP &lsquo;GA VERDER&rsquo; KLIKKEN.
                                    </strong>
                                </p>
                                <p className="o-col-12 spaced-text">
                                    <strong>Heeft je organisatie in het verleden al tochten aangevraagd via de E-tool Toertochten?</strong><br />
                                    Om deze tochten te kunnen weergeven in het nieuwe &lsquo;Platform voor Routegebonden Activiteiten&rsquo; vragen we om de aanmeldcode(s) die je de afgelopen 3 jaar gebruikte, in te vullen.
                                </p>
                                <p className="o-col-12 spaced-text">
                                    <strong>Gebruikte je in het verleden meerdere aanmeldcodes?</strong><br />
                                    Op 19 augustus 2026 ontving je een mail met een overzicht van deze codes.<br />
                                    (afzender: Ondersteuning routegebonden activiteiten - {this.renderEmail()}).
                                </p>
                                <p className="o-col-12 spaced-text">Vul <u>al deze codes</u> in bij je eerste aanmelding. Nadien is een koppeling van je account met vroegere aanvragen niet meer mogelijk.</p>
                                <p className="o-col-12 spaced-text">Kan je de mail niet meer terugvinden? Neem dan contact op via bovenstaand e-mailadres.</p>
                                <p className="o-col-12">
                                    <strong>Heb je geen oude aanmeldcode(s)?</strong><br />
                                    Dan kan je meteen verder gaan naar het volgende scherm.
                                </p>
                            </div>

                            <div className="c-content-block">
                                {codes.map((code, index) => this.renderRij(code, index))}
                            </div>

                            <div className="c-content-block" style={{ textAlign: "right" }}>
                                <button type="button" className="c-button" disabled={bezig} onClick={this.onGaVerder}>Ga verder</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    renderEmail() {
        const email = this.props.email;
        if (!email)
            return null;

        return <a href={`mailto:${email}`}>{email}</a>;
    }

    renderRij(code, index) {
        const fout = this.state.fouten[(code || "").trim()];
        const isLaatste = index === this.state.codes.length - 1;

        return (
            <div className="o-grid" key={index}>
                <TextInput
                    name={`aanmeldcode-${index}`}
                    label="Oude aanmeldcode"
                    value={code}
                    size={9}
                    onChange={(event) => this.onCodeChange(index, event.target.value)}
                    validationMessage={fout} />
                <div className="o-col-3" style={{ display: "flex", alignItems: "center" }}>
                    <button type="button" className="c-button" style={{ marginRight: "8px" }} onClick={() => this.onRemoveRow(index)}>-</button>
                    {isLaatste ? <button type="button" className="c-button" onClick={this.onAddRow}>+</button> : null}
                </div>
            </div>
        );
    }
}

OrbMigratiePage.propTypes = {
    security: PropTypes.object,
    email: PropTypes.string,
    loadLayout: PropTypes.func.isRequired,
    ajaxActions: PropTypes.object.isRequired,
    throwException: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    const parameters = (state.referentie && state.referentie.parameters) || [];
    const email = parameters.find(param => param.value === "vtT.Emails.HoofdbestuurEmail");

    return {
        security: state.security,
        email: email ? email.label : null
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadOrbMigratiePageLayout, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrbMigratiePage);
